const RELAY_RESPONSES = {
  DUPLICATE_REQUEST: 'Your request cannot be completed at this time',
};

const ERROR_STRINGS = {
  SIGN_IN_FAILURE: `We didn’t recognize the phone number or password you entered. Please try again.`,
  DUPLICATE_REQUEST:
    'An interpreter has already been requested. Please wait a moment for the interpreter to join.',
  UNABLE_TO_REQUEST:
    'We were unable to request an interpreter right now, please try again later.',
  UNAUTHORIZED_PHONE:
    'Sorry; it looks like this phone number isn’t authorized to make a VRS call. Want to try again? Or ',
};

const VIDEO = {
  SIGN_IN: {
    PREVIEW_PICTURE: './loginVideoPreview.jpg',
    URL: 'https://assets.frame.io/encode/498213a6-b933-40bd-8be0-ab7cc69e6280/h264_1080_best.mp4?x-amz-meta-project_id=4ec392a3-632e-4725-af4c-ddf11d7a65c5&x-amz-meta-request_id=F1WEEaQdu4HXkW8H8OCG&x-amz-meta-project_id=4ec392a3-632e-4725-af4c-ddf11d7a65c5&x-amz-meta-resource_type=asset&x-amz-meta-resource_id=498213a6-b933-40bd-8be0-ab7cc69e6280&Expires=1681473600&Signature=d1KG1tjE58PrMNu7oTMnzaKawWr-xTLMfdu-rtWYNCL4AbAxzGBcVEEHWhhebdBK~gdDjFWBAusYUUGZDjIUrt0MCGp062WfM~Jxj424Ms5uUbp2dr2227l86S-XKIMT~bJQJksgJalodzkCbrtxvQyhZoHY09qVRFXwnCtoCXyKYd7ZAGUn~kW1tiqjRg6SM-ErpRAwmGYltVw5lWN0NrMorKhwQqSyEvjZ5AULPUEtvTRuSrniRA2WIYvazM0iT3vZjLPHyt6m5BPriLzwIGcnOpRo9iMEhoLxg9Hawcj4vqCLVQ5-Bqbw36GGHxoNZAA~pMsRxqqibO4xUAErMw__&Key-Pair-Id=K1XW5DOJMY1ET9',
  },
};

export { RELAY_RESPONSES, ERROR_STRINGS, VIDEO };
